<template>
    <div v-if="courses_modules.length > 0">
        <div v-for="(item, mindex) in courses_modules" :key="mindex">
            <div class="col-xs-12 override-padding mb-2">
                <div class="row">
                    <div class="col-1">&nbsp;&nbsp;&nbsp;</div>
                    <div class="col-11" style="display: flex;">
                        <div class="float-left courses_row courses_content_1 text-align-left">{{ formatModuleName(item.module_name, mindex)  }}</div>
                        <div class="float-left courses_row courses_content_2 text-align-center">&nbsp;&nbsp;</div>
                        <div class="float-left courses_row courses_content_3 text-align-center">
                            <i class="fa fa-check" v-if="item.pass === 'Pass'"></i>
                            <span v-else>&nbsp;</span>
                        </div>
                        <div class="float-left courses_row courses_content_4 text-align-center">
                            <span v-if="item.score != 'N/A'">{{ item.score }}%</span>
                            <span v-else>&nbsp;</span>
                        </div>
                        <div class="float-left courses_row courses_content_5 text-align-center">&nbsp;&nbsp;</div>
                        <div class="float-left courses_row courses_content_6 text-align-center">
                            <span v-if="item.module_attended_date != 'N/A'">{{ item.module_attended_date | formatModuleDate }}</span>
                            <span v-else>&nbsp;</span>
                        </div>
                        <div class="float-left courses_row courses_content_7 text-align-left">&nbsp;&nbsp;</div>
                    </div>
                </div>
                <hr class="courses_hr" v-if="mindex == courses_modules.length">
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import moment from 'moment';

Vue.filter('formatModuleDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
    data(){
        return{
            courses_modules: [],
        }
    },
    methods: {
        getModules(userId, courseId, displayFlag) {
          var account_id = document.getElementById("accountId").value;
          if (displayFlag) {
            axios('/custom/account-courses',
            {
              method: 'POST',
              data: {
                user_id: userId,
                course_id: courseId,
                account_id: account_id,
                learn_lms_key: 'MENTOR_BAZINGA!!!'
              }
            }
            )
            .then(response => {
              if (response.data.success) {
                this.courses_modules = response.data.data.courses[courseId].modules;
              }
            })
            .catch(error => {

            });
          } else {
            this.courses_modules = [];
          }
        },
        formatModuleName(name, num) {
          return (num +1) + '. ' + name;
        }
    }
}
</script>

<style scoped>
/* Courses css start */
.courses_heading_0 {
  width: 5%;
  font-weight: 900;
}
.courses_heading_1 {
  width: 30%;
}
.courses_heading_2 {
  width: 10%;
}
.courses_heading_3 {
  width: 8%;
}
.courses_heading_4 {
  width: 12%;
}
.courses_heading_5 {
  width: 15%;
}
.course_header {
  background: #707070 none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.courses_content_1 {
  width: 31.66%;
}
.courses_content_2 {
  width: 6%;
}
.courses_content_3 {
  width: 15%;
}
.courses_content_4 {
  width: 7%;
}
.courses_content_5 {
  width: 11%;
}
.courses_content_6 {
  width: 7%;
}
.courses_content_7 {
  width: 22%;
}
.courses_row {
  border-bottom: 1px solid #00ACEE;
  padding: 5px 0px;
}
.courses_hr {
  margin: 30px 0px;
  border-bottom: 2px solid #00ACEE;
}
@media (max-width: 768px) {
  .course_header {
    padding: 8px 1px;
    font-size: 11px;
  }
}
.download_cert_link, .download_cert_link:hover, .download_cert_link:active, .download_cert_link:focus{
  color: #FFF !important;
}
/* Courses css end */
</style>


// WEBPACK FOOTER //
// src/components/admin/course_user_results_modules.vue